import { render } from "./MenuEditing.vue?vue&type=template&id=5a43e2fe"
import script from "./MenuEditing.vue?vue&type=script&lang=js"
export * from "./MenuEditing.vue?vue&type=script&lang=js"
script.render = render

export default script